<template>
  <router-view></router-view>
</template>

<script>
import "@/assets/css/bgrid.min.css";
import "@/assets/css/style.css";
import "@/assets/css/responsive.css";

export default {
  data() {
    return {
      isLoading: false,
    };
  },
  mounted() {
    this.isLoading = true;
  },
};
</script>
<style>
</style>
